var map = {
	"./events/food_balcony.jpeg": 15877,
	"./events/wedding.jpeg": 22096,
	"./events/wedding_dinner.jpeg": 82194,
	"./hotel/background.jpeg": 25847,
	"./hotel/balcony.jpeg": 87436,
	"./hotel/banner_desktop.jpg": 38019,
	"./hotel/banner_desktop_no_logo.jpeg": 27305,
	"./hotel/banner_mobile.jpg": 59079,
	"./hotel/bath_room1.jpeg": 5011,
	"./hotel/bath_room2.jpeg": 93625,
	"./hotel/bathroom.jpeg": 45422,
	"./hotel/bathroom2.jpeg": 61740,
	"./hotel/bathroom3.jpg": 35085,
	"./hotel/beach.jpeg": 77350,
	"./hotel/bg-masthead2.jpg": 22024,
	"./hotel/diving.jpg": 44215,
	"./hotel/entrance.png": 79281,
	"./hotel/frontside.jpeg": 27681,
	"./hotel/frontside2.jpg": 88879,
	"./hotel/hotel.jpg": 7864,
	"./hotel/inside.jpg": 40971,
	"./hotel/inside_day.jpeg": 23216,
	"./hotel/inside_day2.jpeg": 44967,
	"./hotel/inside_sunset.jpeg": 45418,
	"./hotel/inside_xmas.jpeg": 78500,
	"./hotel/pool_closeup.jpeg": 67284,
	"./hotel/pool_day.jpeg": 40817,
	"./hotel/pool_day2.jpeg": 52040,
	"./hotel/pool_day_2.jpeg": 25689,
	"./hotel/pool_day_2_2.jpeg": 45563,
	"./hotel/pool_night.jpeg": 16231,
	"./hotel/sailboat.jpg": 13501,
	"./hotel/scroll_horizontal.png": 41643,
	"./hotel/sunset1.jpg": 24231,
	"./hotel/sunset2.jpg": 53034,
	"./hotel/sunset3.jpg": 48095,
	"./hotel/veranda_day1.jpeg": 90427,
	"./hotel/veranda_day1_2.jpeg": 12014,
	"./hotel/veranda_day2.jpeg": 86818,
	"./hotel/veranda_day3.jpeg": 23407,
	"./hotel/veranda_day4.jpeg": 13583,
	"./hotel/veranda_day5.jpeg": 82023,
	"./hotel/veranda_day_6.jpeg": 70272,
	"./hotel/veranda_sunset.jpeg": 23309,
	"./hotel/veranda_sunset2.jpeg": 68823,
	"./logo/leaflogo.png": 91549,
	"./logo/logo.svg": 95654,
	"./logo/logo_black.png": 55736,
	"./logo/logo_new.png": 90662,
	"./logo/logo_text.svg": 91174,
	"./logo/logo_white.png": 34557,
	"./logo/logo_with_text.svg": 66119,
	"./logo/logo_with_text_below.svg": 23994,
	"./logo/logo_with_text_white_background.svg": 83045,
	"./logo/logo_with_white_background.svg": 95770,
	"./logo/logoblack.png": 70295,
	"./logo/logowhite.png": 77710,
	"./logo/navlogo.png": 30560,
	"./logo/wordlogo2.png": 20473,
	"./new/DSCF3564.jpg": 94419,
	"./new/DSCF3565.jpg": 43904,
	"./new/DSCF3570.jpg": 26360,
	"./new/DSCF3576.jpg": 41735,
	"./new/DSCF3589.jpg": 98490,
	"./new/DSCF3598.jpg": 28082,
	"./new/DSCF3600.jpg": 16963,
	"./new/DSCF3603.jpg": 49526,
	"./new/DSCF3604.jpg": 41592,
	"./new/DSCF3605.jpg": 34944,
	"./new/DSCF3615.jpg": 57636,
	"./new/DSCF3623.jpg": 66047,
	"./new/DSCF3632.jpg": 1902,
	"./new/DSCF3642.jpg": 67466,
	"./new/DSCF3652.jpg": 36584,
	"./new/DSCF3653.jpg": 60101,
	"./new/DSCF3659.jpg": 12082,
	"./new/DSCF3669.jpg": 41483,
	"./new/DSCF3673.jpg": 35476,
	"./new/DSCF3689.jpg": 25477,
	"./new/DSCF3693.jpg": 45193,
	"./new/DSCF3695.jpg": 32609,
	"./new/balcony.jpg": 45177,
	"./new/drone_pool.jpg": 41369,
	"./new/drone_pool2.jpg": 55979,
	"./new/drone_sea_view.jpg": 44182,
	"./new/drone_sea_view2.jpg": 51263,
	"./new/entrance.jpg": 14964,
	"./new/entrance2.jpg": 26411,
	"./new/palms.jpg": 97602,
	"./new/pool.jpg": 43886,
	"./new/pool10.jpg": 7527,
	"./new/pool11.jpg": 15870,
	"./new/pool2.jpg": 3419,
	"./new/pool3.jpg": 29350,
	"./new/pool4.jpg": 26612,
	"./new/pool5.jpg": 37179,
	"./new/pool6.jpg": 30173,
	"./new/pool7.jpg": 42097,
	"./new/pool8.jpg": 78772,
	"./new/pool9.jpg": 76747,
	"./new/pool_reading_book.jpg": 54661,
	"./new/pool_relaxing.jpg": 29657,
	"./new/pool_sea_view.jpg": 93847,
	"./new/reception.png": 28059,
	"./new/room_sea_view.jpg": 28110,
	"./new/room_sea_view2.jpg": 98805,
	"./new/room_sea_view3.jpg": 53549,
	"./new/room_sea_view4.jpg": 12450,
	"./new/room_sea_view_balcony.jpg": 16949,
	"./new/room_sea_view_balcony2.jpg": 74477,
	"./new/sea_view_day.jpg": 42318,
	"./new/sea_view_sunset.jpg": 13034,
	"./new/sunny_sea_view.jpg": 95878,
	"./new/sunny_sea_view_small.jpg": 14669,
	"./rooms/IMG_0927.jpg": 59831,
	"./rooms/IMG_1052.jpg": 48407,
	"./rooms/bathroom.jpg": 24128,
	"./rooms/bathroom2.jpg": 91064,
	"./rooms/bathroom3.jpg": 1740,
	"./rooms/bathroom4.jpg": 20320,
	"./rooms/bathroom5.jpg": 19013,
	"./rooms/mountain_view_queen/IMG_0941.jpg": 36928,
	"./rooms/mountain_view_queen/IMG_0964.jpg": 49422,
	"./rooms/mountain_view_queen/IMG_0972.jpg": 27646,
	"./rooms/mountain_view_queen/IMG_0977.jpg": 58917,
	"./rooms/ocean_view_king/IMG_1151.jpg": 87806,
	"./rooms/ocean_view_king/IMG_1153.jpg": 86774,
	"./rooms/ocean_view_king/IMG_1159.jpg": 92516,
	"./rooms/ocean_view_king/IMG_1160.jpg": 91899,
	"./rooms/ocean_view_king/IMG_1161.jpg": 68277,
	"./rooms/ocean_view_king/IMG_1162.jpg": 36112,
	"./rooms/ocean_view_king/IMG_1164.jpg": 2276,
	"./rooms/ocean_view_queen/IMG_0842.jpg": 61005,
	"./rooms/ocean_view_queen/IMG_0854.jpg": 58930,
	"./rooms/ocean_view_queen/IMG_0862.jpg": 74929,
	"./rooms/ocean_view_queen/IMG_0875.jpg": 23680,
	"./rooms/ocean_view_queen/IMG_0883.jpg": 81463,
	"./rooms/ocean_view_queen/IMG_0895.jpg": 49108,
	"./rooms/ocean_view_queen/IMG_0900.jpg": 38834,
	"./rooms/ocean_view_queen/IMG_0909.jpg": 76157,
	"./rooms/ocean_view_queen/IMG_0920.jpg": 28635,
	"./rooms/ocean_view_queen/IMG_0921.jpg": 53840,
	"./rooms/ocean_view_queen/IMG_0925.jpg": 51997,
	"./rooms/ocean_view_queen/IMG_0927.jpg": 63633,
	"./rooms/ocean_view_queen/IMG_0931.jpg": 83575,
	"./rooms/ocean_view_queen/IMG_0937.jpg": 14857,
	"./rooms/ocean_view_queen/IMG_1006.jpg": 86167,
	"./rooms/ocean_view_queen/IMG_1022.jpg": 82150,
	"./rooms/ocean_view_queen/IMG_1032.jpg": 70210,
	"./rooms/ocean_view_suite/bathroom.jpeg": 47573,
	"./rooms/ocean_view_suite/bathroom.jpg": 73728,
	"./rooms/ocean_view_suite/bathroom_view.jpg": 66005,
	"./rooms/ocean_view_suite/bed.jpeg": 54009,
	"./rooms/ocean_view_suite/bed2.jpeg": 31435,
	"./rooms/ocean_view_suite/bed2.jpg": 13837,
	"./rooms/ocean_view_suite/bed4.jpg": 39946,
	"./rooms/ocean_view_suite/living_area.jpg": 30058
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32711;